// extracted by mini-css-extract-plugin
module.exports = {"Btn":"TrainingsFilter_Btn__aCGc6","TrainingsFilter":"TrainingsFilter_TrainingsFilter__teKRy"};